import {
  SharedModule,
  CustomDetailComponent,
  DataService,
  NotificationService,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import {
  Component,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormGroup, UntypedFormGroup } from "@angular/forms";
import { Observable, take, Subject, takeUntil } from "rxjs";
import {
  DeleteFreeGiftConditionDocument,
  FetchVariantGiftListQuery,
  GetProductSupplierDocument,
  UpdateFreeGiftConditionDocument,
} from "../generated-graphql/graphql";
import AddContidionDialogComponent from "../FreeGiftsNg/Add-Condition/add-condition.component";

@Component({
  standalone: true,
  selector: "condition-card",
  templateUrl: "./condition-card.component.html",
  styleUrl: "./condition-card.component.scss",
  imports: [SharedModule],
})
export default class ConditionCardComponent {
  constructor(
    private dataService: DataService,
    private notificationService: NotificationService,
    private modalService: ModalService
  ) {}

  @Input()
  productId: string;

  @Input()
  productName: string;

  @Input()
  condition: FetchVariantGiftListQuery["variantFreeGiftSelectionsFromProductId"]["0"]["conditions"][0];

  @Input()
  detailForm: UntypedFormGroup;

  @Output()
  refetch = new EventEmitter();

  salt = {
    stockLevel: 8691830722372749, // Ví dụ số bí mật
  };

  decodeStock(stockLevel: string) {
    return (this.salt.stockLevel ^ Number(stockLevel)).toString();
  }

  fetchRetailerAndArtist(
    callback: ({
      retailer,
      artist,
    }: {
      retailer: string;
      artist: string;
    }) => void
  ) {
    this.dataService
      .query(GetProductSupplierDocument, { id: this.productId })
      .single$.pipe(take(1))
      .subscribe((res) => {
        if (!res.product) return;

        const retailer = res.product.customFields?.retailer;
        if (!retailer) {
          this.notificationService.error(
            "Retailer not found, Please add retailer to product"
          );
          return;
        }

        const artist = res.product.customFields?.artist;
        if (!artist) {
          this.notificationService.error(
            "Artist not found, Please add artist to product"
          );
          return;
        }

        callback({ retailer: retailer.id, artist: artist.id });
      });
  }

  editCondition() {
    this.fetchRetailerAndArtist(({ retailer, artist }) => {
      this.modalService
        .fromComponent(AddContidionDialogComponent, {
          size: "lg",
          closable: true,
          locals: {
            condition: this.condition,
            productRetailer: retailer,
            productArtist: artist,
            productName: this.productName,
          },
        })
        .pipe(take(1))
        .subscribe((result) => {
          console.log("Update Result", result);

          if (result.productVariants.length <= 0) {
            this.dataService
              .mutate(DeleteFreeGiftConditionDocument, {
                id: this.condition.id,
              })
              .pipe(take(1))
              .subscribe((res) => {
                if (res.deleteFreeGiftCondition) {
                  this.notificationService.success(
                    "Condition Deleted Successfully"
                  );
                  this.refetch.emit();
                }
              });
          } else {
            this.dataService
              .mutate(UpdateFreeGiftConditionDocument, {
                input: {
                  id: this.condition.id,
                  giftQuantity: result.giftQuantity,
                  minQuantity: result.minQuantity,
                  productVariantIds: result.productVariants,
                },
              })
              .pipe(take(1))
              .subscribe((res) => {
                if (
                  res.updateFreeGiftCondition.__typename === "FreeGiftCondition"
                ) {
                  this.notificationService.success(
                    "Condition Updated Successfully"
                  );
                  this.refetch.emit();
                }
              });
          }
        });
    });
  }

  delete(id: string) {
    this.modalService
      .dialog({
        title: "Delete Condition",
        body: `Are you sure you want to delete this condition?`,
        buttons: [
          { label: "Cancel", type: "secondary", returnValue: false },
          { label: "Delete", type: "danger", returnValue: true },
        ],
      })
      .pipe(take(1))
      .subscribe((res) => {
        if (res) {
          this.dataService
            .mutate(DeleteFreeGiftConditionDocument, {
              id,
            })
            .pipe(take(1))
            .subscribe((res) => {
              if (res.deleteFreeGiftCondition) {
                this.notificationService.success(
                  "Condition Deleted Successfully"
                );
                this.refetch.emit();
              }
            });
        }
      });
  }
}
